@if (!lyView) {
    <div class="d-flex flex-row flex-wrap align-items-center mt-8" [ngClass]="classAlign">
        <ng-content></ng-content>
    </div>
}
